/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Clean_TextInputs */



/**
* | output |
* | --- |
* | "Clean Up Text" |
*
* @param {Context_Menu_Clean_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_clean_text = /** @type {((inputs?: Context_Menu_Clean_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Clean_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nettoyer le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text bereinigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pulisci il testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистка текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limpiar texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清理文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストのクリーンアップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को साफ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar texto")
	return /** @type {LocalizedString} */ ("Clean Up Text")
});